import {useEffect} from 'react'
import {isServer} from '@salesforce/retail-react-app/app/utils/utils'
import {EU_DOMESTIC_COUNTRY_CODES} from '../constants'

export const RISKIFIED_BEACON_SCRIPT_ID = 'riskified-beacon-script'

export const shouldInjectRiskifiedBeacon = ({riskifiedDomain, riskifiedBeacon, shipToCountryId}) =>
    !isServer &&
    Boolean(riskifiedDomain) &&
    Boolean(riskifiedBeacon) &&
    Boolean(shipToCountryId) &&
    !EU_DOMESTIC_COUNTRY_CODES.includes(shipToCountryId)

export const injectRiskifiedBeacon = ({riskifiedDomain, riskifiedBeacon, shipToCountryId}) => {
    if (
        !shouldInjectRiskifiedBeacon({riskifiedDomain, riskifiedBeacon, shipToCountryId}) ||
        document.getElementById(RISKIFIED_BEACON_SCRIPT_ID)
    ) {
        return
    }

    const url = new URL(`${document.location.protocol}//beacon.riskified.com`)
    url.searchParams.set('shop', riskifiedDomain)
    url.searchParams.set('sid', riskifiedBeacon)

    const script = document.createElement('script')
    script.id = RISKIFIED_BEACON_SCRIPT_ID
    script.type = 'text/javascript'
    script.async = true
    script.src = url.toString()

    const firstScript = document.getElementsByTagName('script')[0]
    if (firstScript?.parentNode) {
        firstScript.parentNode.insertBefore(script, firstScript)
    } else {
        document.head.appendChild(script)
    }
}

export const setupRiskifiedBeacon = ({riskifiedDomain, riskifiedBeacon, shipToCountryId}) => {
    if (!shouldInjectRiskifiedBeacon({riskifiedDomain, riskifiedBeacon, shipToCountryId})) {
        return undefined
    }

    const loadRiskifiedBeacon = () => {
        injectRiskifiedBeacon({riskifiedDomain, riskifiedBeacon, shipToCountryId})
    }

    if (document.readyState === 'complete') {
        loadRiskifiedBeacon()
        return undefined
    }

    window.addEventListener('load', loadRiskifiedBeacon, {once: true})

    return () => {
        window.removeEventListener('load', loadRiskifiedBeacon)
    }
}

const useRiskifiedBeacon = ({riskifiedDomain, riskifiedBeacon, shipToCountryId}) => {
    useEffect(() => {
        return setupRiskifiedBeacon({riskifiedDomain, riskifiedBeacon, shipToCountryId})
    }, [riskifiedDomain, riskifiedBeacon, shipToCountryId])
}

export default useRiskifiedBeacon
